var __typeError = (msg) => {
  throw TypeError(msg);
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _handleKeydown, _QuantitySelector_instances, onQuantityChange_fn, _checkQuantityRules;
import { C as Component } from "./component-cLJ9vlHA.js";
import { Q as QuantitySelectorUpdateEvent } from "./events-DeC3n8dp.js";
import "./critical-Da0Dmhh9.js";
import "./utilities-2Suih3Nm.js";
class QuantitySelector extends Component {
  constructor() {
    super();
    __privateAdd(this, _QuantitySelector_instances);
    __privateAdd(this, _handleKeydown, (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
        this.setQuantity(event);
      }
    });
    __privateAdd(this, _checkQuantityRules, (event) => {
      const { quantityInput, quantityButtons } = this.refs;
      const { min, max, value: newValue } = quantityInput;
      const minusButton = quantityButtons[0];
      const plusButton = quantityButtons[1];
      if (min) {
        if (newValue <= min) minusButton.setAttribute("disabled", "true");
        else minusButton.removeAttribute("disabled");
      }
      if (max) {
        if (newValue >= max) plusButton.setAttribute("disabled", "true");
        else plusButton.removeAttribute("disabled");
      }
      if (newValue < min && min) quantityInput.value = min;
      if (newValue > max && max) quantityInput.value = max;
    });
  }
  connectedCallback() {
    super.connectedCallback();
    this.previousQuantity = parseInt(this.quantityInput.value);
    this.quantityInput.addEventListener("keydown", __privateGet(this, _handleKeydown));
  }
  disconnectedCallback() {
    var _a;
    super.disconnectedCallback();
    (_a = this.quantityInput) == null ? void 0 : _a.removeEventListener("keydown", __privateGet(this, _handleKeydown));
  }
  validateNumeric() {
    if (this.quantityInput.validity.badInput || !this.quantityInput.value || isNaN(Number(this.quantityInput.value))) {
      this.quantityInput.value = this.previousQuantity || this.quantityInput.min || 1;
    } else {
      this.previousQuantity = this.quantityInput.value;
    }
  }
  increaseQuantity(event) {
    if (!(event.target instanceof HTMLElement)) return;
    event.preventDefault();
    this.refs.quantityInput.stepUp();
    __privateMethod(this, _QuantitySelector_instances, onQuantityChange_fn).call(this, event);
  }
  decreaseQuantity(event) {
    if (!(event.target instanceof HTMLElement)) return;
    event.preventDefault();
    this.refs.quantityInput.stepDown();
    __privateMethod(this, _QuantitySelector_instances, onQuantityChange_fn).call(this, event);
  }
  selectInputValue(event) {
    const { quantityInput } = this.refs;
    if (!(event.target instanceof HTMLInputElement) || document.activeElement !== quantityInput) return;
    quantityInput.select();
  }
  setQuantity(event) {
    if (!(event.target instanceof HTMLElement)) return;
    event.preventDefault();
    if (event.target instanceof HTMLInputElement) {
      this.refs.quantityInput.value = event.target.value;
    }
    const newValue = parseInt(this.quantityInput.value);
    if (newValue === this.previousQuantity) return;
    __privateMethod(this, _QuantitySelector_instances, onQuantityChange_fn).call(this, event);
  }
  get quantityInput() {
    if (!this.refs.quantityInput) {
      throw new Error('Missing <input ref="quantityInput" /> inside <quantity-selector-component />');
    }
    return this.refs.quantityInput;
  }
}
_handleKeydown = new WeakMap();
_QuantitySelector_instances = new WeakSet();
onQuantityChange_fn = function(event) {
  const { quantityInput } = this.refs;
  this.validateNumeric();
  __privateGet(this, _checkQuantityRules).call(this, event);
  const newValue = parseInt(quantityInput.value);
  quantityInput.dispatchEvent(new QuantitySelectorUpdateEvent(newValue, Number(quantityInput.dataset.cartLine)));
};
_checkQuantityRules = new WeakMap();
if (!customElements.get("quantity-selector-component")) {
  customElements.define("quantity-selector-component", QuantitySelector);
}
